<template>
  <div
    v-if="!adMode.developer"
    :id="container"
    class="min-h-[360px] relative"
    :class="{ 'p-2.5': mode === 'thumbnails', 'flex items-center justify-center': mode === 'thumbnails-c' }"
    :style="{ background: mode === 'thumbnails' ? '#f7f8fb' : null }"
  ></div>
</template>
<script>
import { defineComponent, onMounted, inject, ref, useRoute } from '@nuxtjs/composition-api';
import { LANG, HOST_URL } from '~/constants/config';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';

export default defineComponent({
  name: 'taboola',
  props: {
    targeting: {
      type: String,
      default: 'article',
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const adMode = inject('adConfig');
    const adUrl = ref('');
    const route = useRoute();
    const modes = {
      infinite: {
        mode: 'thumbnails-b',
        placement: `Below Article Thumbnails ${ctx.attrs['is-stn-active'] ? 'Widget' : 'Feed'}${ctx?.attrs['stn-page'] ? ' scroll' : ''}`,
        container: 'below-article-thumbnails',
      },
      thumbnails: {
        mode: 'thumbnails-3x3',
        placement: `Before Infinite Scroll Thumbnails ${ctx.attrs['is-stn-active'] ? 'Widget' : 'Feed'}${
          ctx?.attrs['stn-page'] ? ' scroll' : ''
        }`,
        container: `before-infinite-scroll-thumbnails${ctx?.attrs['stn-page'] ? '-' + ctx?.attrs['stn-page'] : ''}`,
      },
      rightrail: {
        mode: 'thumbnails-rr-a',
        placement: 'Right Rail Thumbnails',
        container: 'right-rail-thumbnails',
      },
      nowidget: {
        mode: 'rbox-tracking',
        placement: 'Newsroom',
        container: 'taboola-newsroom',
      },
      videoreel: {
        mode: 'video-reel-sc',
        container: 'taboola-video-reel-right-rail',
        placement: 'Video Reel Right Rail',
      },
      midarticle: {
        mode: 'thumbnails-a-midarticle-desktop',
        container: 'taboola-below-article-thumbnails',
        placement: 'Below Article Thumbnails Mid Article',
      },
      bottomarticle: {
        mode: 'thumbnails-a-midarticle-desktop',
        placement: 'Below Article Thumbnails Bottom Article',
        container: `taboola-below-article-thumbnails-bottom${ctx?.attrs['stn-page'] ? '-' + ctx?.attrs['stn-page'] : ''}`,
      },
      belowarticle: {
        mode: 'thumbnails-c',
        placement: `Below article thumbnails new ${ctx.attrs['is-stn-active'] ? 'widget' : 'feed'}${
          ctx?.attrs['stn-page'] ? ' scroll' : ''
        }`,
        container: `below-article-thumbnails-new${ctx?.attrs['stn-page'] ? '-' + ctx?.attrs['stn-page'] : ''}`,
      },
    };

    const taboolaScripts = {
      tr: '//cdn.taboola.com/libtrc/onedio/loader.js',
      en: '//cdn.taboola.com/libtrc/onedio-onedioco/loader.js',
      ru: '//cdn.taboola.com/libtrc/onedio-russia-ru/loader.js',
    };

    onMounted(() => {
      if (!adMode.value.developer) {
        // get article url according to stn
        adUrl.value =
          HOST_URL + (ctx?.attrs['stn-page'] ? getArticleUrl({ article: window.stnList[ctx?.attrs['stn-page'] - 1] }) : route.value.path);
        window._taboola = window._taboola || [];
        window._taboola.push({ [props.targeting]: 'auto', url: adUrl.value });
        (function (e, f, u, i) {
          if (!document.getElementById(i)) {
            e.async = 1;
            e.src = u;
            e.id = i;
            f.parentNode.insertBefore(e, f);
          }
        })(document.createElement('script'), document.getElementsByTagName('script')[0], taboolaScripts[LANG], 'tb_loader_script');
        if (window.performance && typeof window.performance.mark === 'function') {
          window.performance.mark('tbl_ic');
        }
        window._taboola.push({
          mode: modes[props.mode].mode,
          container: modes[props.mode].container,
          placement: modes[props.mode].placement,
          target_type: 'mix',
        });
      }
    });
    return { container: modes[props.mode].container, adMode };
  },
});
</script>
